export default __webpack_public_path__ + "static/media/mobile-app-image.cfd52703.svg";